import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { Scroll } from '@snack-uikit/scroll';
import { QuestionTooltip } from '@snack-uikit/tooltip';
import { Typography } from '@snack-uikit/typography';
import { useAdaptive } from '../../../hooks';
import { formatNumber, getPrice, getValue, setValue } from '../../../utils';
import { ObjectDecorator } from '../ObjectDecorator';
import { StepperControlUi } from '../StepperControl';
import { StepperWithAllowedValues } from './helperComponents';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TableControlUi(_ref) {
  var rows = _ref.rows,
    counter = _ref.counter,
    decoratorProps = _ref.decoratorProps,
    valueProp = _ref.value,
    onChangeProp = _ref.onChange,
    priceList = _ref.priceList,
    accessorKey = _ref.accessorKey;
  var _useAdaptive = useAdaptive(),
    isMobile = _useAdaptive.isMobile;
  var onChange = function onChange(accessorKey) {
    return function (newValue) {
      setValue(valueProp, accessorKey, newValue);
      onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(valueProp);
    };
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.headline,
      "data-mobile": isMobile || undefined,
      children: [/*#__PURE__*/_jsx(ObjectDecorator, _objectSpread({}, decoratorProps)), counter && /*#__PURE__*/_jsxs("div", {
        className: styles.counter,
        children: [/*#__PURE__*/_jsxs(Typography.SansBodyS, {
          children: [" ", counter.label]
        }), /*#__PURE__*/_jsx(StepperControlUi, {
          value: getValue(valueProp, counter.accessorKey),
          onChange: onChange(counter.accessorKey),
          uiProps: _objectSpread({
            min: 1,
            size: 's',
            showHint: false
          }, counter.uiProps),
          accessorKey: accessorKey,
          type: "stepper",
          decoratorProps: {}
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.table,
      children: /*#__PURE__*/_jsxs(Scroll, {
        barHideStrategy: "never",
        children: [/*#__PURE__*/_jsxs("div", {
          className: cn(styles.row, styles.header),
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.cell,
            children: "\u0420\u0435\u0441\u0443\u0440\u0441"
          }), /*#__PURE__*/_jsx("div", {
            className: styles.cell,
            children: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E"
          }), /*#__PURE__*/_jsx("div", {
            className: styles.cell,
            children: "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0432 \u043C\u0435\u0441\u044F\u0446"
          })]
        }), rows.map(function (_ref2) {
          var accessorKey = _ref2.accessorKey,
            label = _ref2.label,
            labelTooltip = _ref2.labelTooltip,
            labelTooltipPlacement = _ref2.labelTooltipPlacement,
            uiProps = _ref2.uiProps,
            allowedValues = _ref2.allowedValues;
          return /*#__PURE__*/_jsxs("div", {
            className: styles.row,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.cell,
              children: /*#__PURE__*/_jsxs("span", {
                children: [label, "\xA0", labelTooltip && /*#__PURE__*/_jsx("span", {
                  className: styles.tipWrapperInline,
                  children: /*#__PURE__*/_jsx(QuestionTooltip, {
                    "data-pointer": true,
                    tip: labelTooltip,
                    placement: labelTooltipPlacement,
                    size: "xs",
                    tabIndex: -1
                  })
                })]
              })
            }), /*#__PURE__*/_jsx("div", {
              className: styles.cell,
              children: allowedValues ? /*#__PURE__*/_jsx(StepperWithAllowedValues, _objectSpread({
                value: getValue(valueProp, accessorKey),
                onChange: onChange(accessorKey),
                allowedValues: allowedValues
              }, uiProps)) : /*#__PURE__*/_jsx(StepperControlUi, {
                value: getValue(valueProp, accessorKey),
                onChange: onChange(accessorKey),
                uiProps: _objectSpread({
                  showHint: false,
                  min: 0,
                  size: 's'
                }, uiProps),
                type: "stepper",
                decoratorProps: {},
                accessorKey: accessorKey
              })
            }), /*#__PURE__*/_jsx("div", {
              className: styles.cell,
              children: formatNumber(getPrice({
                price: getValue(priceList, accessorKey),
                pricePeriod: 'month'
              })) + ' ₽'
            })]
          }, accessorKey);
        })]
      })
    })]
  });
}